import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import { useAlgoliaData } from '../../../Algolia/hooks/use-algolia-data.js';
import { useFacets } from '../../../hooks/use-facets.js';
import { mapProductsToTealiumViewProperties } from '../../mappers/map-products-to-tealium-view-properties.js';

const TealiumProductListingPageView = ({ productType  })=>{
    const { mappedResults: hits , total  } = useAlgoliaData();
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const { appliedFacets  } = useFacets();
    const plpPageView = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        return swcHelpers.objectSpread({}, commonEventProperties, commonUserProperties, mapProductsToTealiumViewProperties(hits, appliedFacets, total, productType));
    }), // Only need to trigger this page view on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getCommonUserProperties
    ]);
    useTrackPageView(plpPageView);
    return null;
};

export { TealiumProductListingPageView, TealiumProductListingPageView as default };
//# sourceMappingURL=TealiumProductListingPageView.js.map
